import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import i18n from "i18next";
import { postAuthenticatedRequest } from "../../utils/api/requests/request";
import { setAppLanguage } from "../../i18n";

const LanguageContext = createContext();

export const LanguageProvider = ({ children, initialLanguage = "en" }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const normalize = useCallback(
    (lng) =>
      String(lng || "en")
        .toLowerCase()
        .split("-")[0],
    []
  );
  const [language, setLanguageState] = useState(normalize(initialLanguage));

  useEffect(() => {
    console.log("selected language ", language);

    // i18n.changeLanguage(language);

    setAppLanguage(language);
  }, [language]);

  // get translation by key

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOkay = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <LanguageContext.Provider
      value={{
        isModalOpen,
        showModal,
        handleOkay,
        handleCancel,
        language,
        setLanguage: (lng) => setLanguageState(normalize(lng)),
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
